/** 场馆列表 Vue Query key（额度转换 / 游戏浮层 / 余额找回共用） */
export const VENUE_QUERY_KEY = ['wallet', 'venues'] as const
